<template>
	<div class="w-full flex flex-wrap">
		<div class="w-full lg:w-8/12 lg:pr-6">
			<div class="relative mt-4">
				<svg class="absolute top-3.5 right-3 z-0" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.00662 2.18538L10 -5.34058e-05L5.00662 9.74829L8.52246e-07 -5.428e-05L5.00662 2.18538Z" fill="#672240"/>
				</svg>
				<select v-model="section" @change="changeIndexes" class="mt-1 block relative z-30 w-full py-2 tracking-wider rounded-none appearance-none uppercase px-3 border bg-transparent text-hamlet-purple border-hamlet-purple focus:outline-none focus:ring-none">
					<option class="text-hamlet-purple" v-for="(item, index) in items" :key="index+'rp'" :value="index">{{ item.section }}</option>
				</select>
			</div>
			<div class="flex mt-6 w-full">
				<div class="overflow-hidden flex flex-col h-full lg:mr-3">
					<div
							@click="sectionItem = index"
							class="relative mb-5 cursor-pointer hidden lg:block"
							v-for="index in loop" :key="'thumb'+index">
						<img :src="sectionItems[index].thumb" />
						<div class="absolute inset-0 bg-hamlet-pink bg-opacity-90 opacity-0 hover:opacity-100 ease-linear transition-all duration-350">
							<h6 class="uppercase mt-3 ml-3 text-hamlet-purple" v-html="sectionItems[index].heading"></h6>
						</div>
					</div>
					<div class="mt-auto border-b border-black hidden lg:flex justify-around">
						<a href="#" @click.prevent="prevIndex"  class="px-4 py-3"><svg width="10" height="10" class="transform -rotate-90" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#672240"/>
						</svg></a>
						<a href="#" @click.prevent="nextIndex" class="px-4 py-3"><svg width="10" height="10" class="transform rotate-90" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#672240"/>
						</svg></a>
					</div>
				</div>
				<div class="flex flex-wrap w-full lg:w-auto lg:ml-auto">
					<img class="w-full" :src="itemSelected.image" :title="itemSelected.heading" />
					<div class="mt-auto border-b border-black flex w-full lg:hidden justify-around">
						<a href="#" @click.prevent="prevImage"  class="px-4 py-3"><svg width="10" height="10" class="transform -rotate-90" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#672240"/>
						</svg></a>
						<a href="#" @click.prevent="nextImage" class="px-4 py-3"><svg width="10" height="10" class="transform rotate-90" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#672240"/>
						</svg></a>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full lg:w-4/12">
			<div class="mt-20" v-if="items.length">
				<h3 class="text-2xl lg:text-3xl uppercase mt-2  text-hamlet-purple">{{ itemSelected.heading }}</h3>
				<div
						class="mt-10 text-hamlet-purple"
						v-html="itemSelected.topContent"></div>
				<div
						class="small uppercase opacity-50 text-hamlet-purple"
						v-if="itemSelected.caption.length" v-html="itemSelected.caption"></div>
				<div
						class="mt-12 text-hamlet-purple"
						v-html="itemSelected.bottomContent"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "region-gallery",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		background: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			section: 0,
			sectionItem: 0,
			thumbStartIndex: 0,
			thumbEndIndex: 3
		}
	},
	methods: {
		changeIndexes(){
			this.thumbStartIndex = 0;
			const max = this.items[this.section].items.length;
			if(max > 3){
				this.thumbEndIndex = 3;
			}else{
				this.thumbEndIndex = this.items[this.section].items.length;
			}

		},
		nextImage(){
			if(typeof this.sectionItems[this.sectionItem+1] !== 'undefined'){
				this.sectionItem = this.sectionItem + 1;
			}
		},
		prevImage(){
			if(typeof this.sectionItems[this.sectionItem-1] !== 'undefined'){
				this.sectionItem = this.sectionItem - 1;
			}
		},
		nextIndex(){
			const nextStartIndex = this.thumbStartIndex + 1;
			const nextEndIndex = this.thumbEndIndex + 1;

			if(nextEndIndex <= this.sectionItems.length){
				this.thumbStartIndex = nextStartIndex;
				this.thumbEndIndex = nextEndIndex;
			}

		},
		prevIndex(){
			const nextStartIndex = this.thumbStartIndex - 1;
			const nextEndIndex = this.thumbEndIndex - 1;

			if(nextStartIndex >= 0){
				this.thumbStartIndex = nextStartIndex;
				this.thumbEndIndex = nextEndIndex;
			}
		}
	},
	computed: {
		itemSelected() {
			if(!this.items.length){ return null; }
			return this.items[this.section].items[this.sectionItem];
		},
		sectionItems() {
			if(!this.items.length){ return []; }
			return this.items[this.section].items;
		},
		loop() {
			let array = [];
			for (let i = this.thumbStartIndex; i < this.thumbEndIndex; i++) {
				array.push(i);
			}
			return array;
		}

	}
}
</script>

<style scoped>

</style>
